// extracted by mini-css-extract-plugin
export default {"goal-period-section":"ProgressGoalPeriodList--goal-period-section--gjPtB","goalPeriodSection":"ProgressGoalPeriodList--goal-period-section--gjPtB"};